import React from 'react';
import { compose, prop } from 'ramda';
import { branch, lifecycle, renderComponent } from 'recompose';

import connect from 'app/libs/connect';
import { isUserPremium } from 'app/features/user/selectors';
import { isNewExperience } from 'app/features/landing/selectors';
import StackedLayout from 'app/components/layout/StackedLayout';
import Meta from 'app/features/landing/meta/components/Meta';
import HeroBlock from 'app/features/landing/heroBlock/components/HeroBlock';
import Devices from 'app/features/landing/devices/components/Devices';
import SeriesCollection from 'app/features/landing/seriesCollection/components/SeriesCollection';
import ProductComparison from 'app/features/landing/productComparison/components/ProductComparison';
import HelpCenter from 'app/features/helpCenter/components/HelpCenter';
import withCriteoTagTracker from 'app/analytics/enhancers/withCriteoAnalytics';
import { PRODUCT_TAG } from 'app/analytics/constants/criteo';
import {
  setCrFreeTrialCookie,
  setCrPlusCtaMembershipCookie,
  setCrPremPlusCookie,
} from 'app/features/landing/actions';
import { skipFreeTrialReset } from 'app/features/products/actions';
import { couponReset } from 'app/features/couponCampaign/actions';
import NewLanding from 'app/features/newLanding/components/NewLanding';
import CouponLanding from 'app/features/couponCampaign/landing';
import AlreadyPremiumRedirect from 'app/router/AlreadyPremiumRedirect';
import { getCouponCampaignId } from 'app/router/selectors';
import { deviceActivation } from 'app/features/deviceActivation/actions';

const UI = () => (
  <StackedLayout>
    <Meta />
    <StackedLayout.ContentBlock>
      <HeroBlock />
    </StackedLayout.ContentBlock>
    <StackedLayout.ContentBlock>
      <Devices />
    </StackedLayout.ContentBlock>
    <StackedLayout.ContentBlock>
      <SeriesCollection />
    </StackedLayout.ContentBlock>
    <StackedLayout.ContentBlock isContained>
      <ProductComparison />
    </StackedLayout.ContentBlock>
    <StackedLayout.ContentBlock>
      <HelpCenter />
    </StackedLayout.ContentBlock>
  </StackedLayout>
);

UI.displayName = 'Landing';

function componentDidMount() {
  const { skipFreeTrialReset, couponReset, deviceActivation } = this.props;

  setCrPlusCtaMembershipCookie();
  setCrPremPlusCookie();
  setCrFreeTrialCookie();
  skipFreeTrialReset();
  couponReset();
  deviceActivation();
}

const actions = { skipFreeTrialReset, couponReset, deviceActivation };
const state = { isUserPremium, isNewExperience, getCouponCampaignId };

const Landing = compose(
  withCriteoTagTracker(PRODUCT_TAG),
  connect(state, actions),
  branch(prop('isUserPremium'), renderComponent(AlreadyPremiumRedirect)),
  lifecycle({ componentDidMount }),
  branch(prop('isNewExperience'), renderComponent(NewLanding)),
  branch(prop('getCouponCampaignId'), renderComponent(CouponLanding)),
)(UI);

export { UI, componentDidMount };

export default Landing;
